import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";
import _defineProperty from "/vercel/path0/node_modules/next/node_modules/@babel/runtime/helpers/esm/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import * as React from "react";
import DatoImage from "~components/dato-image";
import { postComponents } from "~components/markdown";
import { postPlugins } from "~components/markdown/plugins";
import siteConfig from "~config/site";
import { Box, Button, Center, Container, Divider, Heading, Icon, Stack, Tag, Text, Wrap, WrapItem } from "@chakra-ui/react";
import format from "date-fns/format";
import Head from "next/head";
import NextLink from "next/link";
import { BlogJsonLd, BreadcrumbJsonLd, NextSeo } from "next-seo";
import { FaChevronUp } from "react-icons/fa";
import ReactMarkdown from "react-markdown";

var PostPage = function PostPage(props) {
  var _post$cover, _post$cover$responsiv, _post$cover2, _post$cover2$responsi, _post$cover3, _post$cover3$responsi, _post$cover4, _post$cover4$responsi, _post$cover5, _post$cover5$responsi;

  var post = props.post;
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(Head, {
      children: post._seoMetaTags.map(function (t, key) {
        return /*#__PURE__*/React.createElement(t.tag, _objectSpread({
          key: key
        }, t.attributes), null);
      })
    }), /*#__PURE__*/_jsx(NextSeo, {
      description: post.subtitle,
      openGraph: {
        type: "article",
        article: {
          publishedTime: post._publishedAt,
          modifiedTime: post._updatedAt,
          authors: [siteConfig.siteUrl],
          tags: post.tags.map(function (t) {
            return t.title;
          })
        },
        images: post.cover ? [{
          url: (_post$cover = post.cover) === null || _post$cover === void 0 ? void 0 : (_post$cover$responsiv = _post$cover.responsiveImage) === null || _post$cover$responsiv === void 0 ? void 0 : _post$cover$responsiv.src,
          width: (_post$cover2 = post.cover) === null || _post$cover2 === void 0 ? void 0 : (_post$cover2$responsi = _post$cover2.responsiveImage) === null || _post$cover2$responsi === void 0 ? void 0 : _post$cover2$responsi.width,
          height: (_post$cover3 = post.cover) === null || _post$cover3 === void 0 ? void 0 : (_post$cover3$responsi = _post$cover3.responsiveImage) === null || _post$cover3$responsi === void 0 ? void 0 : _post$cover3$responsi.height,
          alt: (_post$cover4 = post.cover) === null || _post$cover4 === void 0 ? void 0 : (_post$cover4$responsi = _post$cover4.responsiveImage) === null || _post$cover4$responsi === void 0 ? void 0 : _post$cover4$responsi.alt
        }] : undefined
      },
      title: post.title
    }), /*#__PURE__*/_jsx(BlogJsonLd, {
      authorName: "Griko Nibras",
      dateModified: post._updatedAt,
      datePublished: post._publishedAt,
      description: post.subtitle,
      images: post.cover ? [(_post$cover5 = post.cover) === null || _post$cover5 === void 0 ? void 0 : (_post$cover5$responsi = _post$cover5.responsiveImage) === null || _post$cover5$responsi === void 0 ? void 0 : _post$cover5$responsi.src] : [],
      title: post.title,
      url: "".concat(siteConfig.siteUrl, "/blog/").concat(post.slug)
    }), /*#__PURE__*/_jsx(BreadcrumbJsonLd, {
      itemListElements: [{
        position: 1,
        name: "Blog Posts",
        item: "".concat(siteConfig.siteUrl, "/blog")
      }, {
        position: 2,
        name: post.title,
        item: "".concat(siteConfig.siteUrl, "/blog/").concat(post.slug)
      }]
    }), post.cover && /*#__PURE__*/_jsx(Box, {
      bgColor: "whiteAlpha.800",
      maxH: "50vh",
      overflow: "hidden",
      children: /*#__PURE__*/_jsx(DatoImage, {
        data: post.cover.responsiveImage
      })
    }), /*#__PURE__*/_jsx(Container, {
      maxW: "6xl",
      p: [4, 8],
      children: /*#__PURE__*/_jsxs(Stack, {
        align: "center",
        spacing: 4,
        textAlign: "center",
        children: [/*#__PURE__*/_jsx(Heading, {
          size: "2xl",
          children: post.title
        }), /*#__PURE__*/_jsx(Text, {
          color: "whiteAlpha.600",
          fontSize: "lg",
          fontStyle: "italic",
          maxW: "2xl",
          children: post.subtitle
        }), /*#__PURE__*/_jsxs(Text, {
          children: ["Published on ", post._publishedAt ? format(new Date(post._publishedAt), "PPPP") : "UNPUBLISHED"]
        }), /*#__PURE__*/_jsx(Wrap, {
          justify: "center",
          pt: 4,
          children: post.tags.map(function (t) {
            return /*#__PURE__*/_jsx(WrapItem, {
              children: /*#__PURE__*/_jsx(NextLink, {
                href: "/tag/".concat(t.slug),
                passHref: true,
                children: /*#__PURE__*/_jsx(Tag, {
                  as: "a",
                  size: "sm",
                  variant: "subtle",
                  children: t.title
                })
              })
            }, t.slug);
          })
        })]
      })
    }), /*#__PURE__*/_jsx(Divider, {
      maxW: "4xl",
      mx: "auto"
    }), /*#__PURE__*/_jsx(Container, {
      maxW: "4xl",
      p: [4, 8],
      children: /*#__PURE__*/_jsxs(Stack, {
        lineHeight: "tall",
        spacing: 4,
        children: [/*#__PURE__*/_jsx(ReactMarkdown, {
          children: post.content,
          components: postComponents,
          remarkPlugins: postPlugins
        }), /*#__PURE__*/_jsx(Center, {
          pt: 8,
          children: /*#__PURE__*/_jsx(Button, {
            color: "whiteAlpha.700",
            leftIcon: /*#__PURE__*/_jsx(Icon, {
              as: FaChevronUp
            }),
            onClick: function onClick() {
              return window.scrollTo({
                behavior: "smooth",
                top: 0
              });
            },
            size: "sm",
            children: "Back to top"
          })
        })]
      })
    })]
  });
};

export var __N_SSG = true;
export default PostPage;